import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  connect() {
    this.pos = 0
    this.scrollListener = this.onScroll.bind(this)
    window.addEventListener('scroll', this.scrollListener)
  }

  disconnect() {
    window.removeEventListener('scroll', this.scrollListener)
    this.scrollListener = null
  }

  onScroll() {
    const scrollTop =
      document.documentElement.scrollTop || document.body.scrollTop

    if (scrollTop < this.pos) {
      this.element.classList.add('is-active')
    } else {
      this.element.classList.remove('is-active')
    }
    this.pos = scrollTop

    if (window.pageYOffset < 100) {
      this.element.classList.remove('is-active')
    }
  }
}
